<template>
  <div>
    <div class="md-collapse">
      <div
        class="md-collapse-label"
        @click="visible = !visible"
      >
        <h5 class="md-collapse-title regular text-primary">
          <span
            v-if="panelIcon"
            :style="iconStyle"
          ></span>
          {{ name }}
        </h5>
      </div>

      <collapse-transition :duration="350">
        <div v-show="visible" class="md-collapse-content">
          <template v-if="!isToday">
            <div v-for="item in items" :key="item.gid">
              <panel-item v-if="item.itemType == 0" :item="item" :showDetailsLink="true"></panel-item>
              <cultural-event-item
                v-if="item.itemType == 1"
                :item="item"
                @showDetails="onShowCulturalEventDetails(item)"
              ></cultural-event-item>
            </div>
          </template>

          <template v-else>
            <template v-if="recommendedItems.length">
              <div class="agenda-section-label">{{ $t('Recommended events') }}</div>
              <div v-for="item in recommendedItems" :key="item.gid">
                <panel-item v-if="item.itemType == 0" :item="item" :showDetailsLink="true"></panel-item>
                <cultural-event-item
                  v-if="item.itemType == 1"
                  :item="item"
                  @showDetails="onShowCulturalEventDetails(item)"
                ></cultural-event-item>
              </div>
            </template>

            <template v-if="currentAndFutureItems.length">
              <div class="agenda-section-label">{{ $t('Current and upcoming') }}</div>
            </template>
            <div v-for="item in currentAndFutureItems" :key="item.gid">
              <panel-item v-if="item.itemType == 0" :item="item" :showDetailsLink="true"></panel-item>
              <cultural-event-item
                v-if="item.itemType == 1"
                :item="item"
                @showDetails="onShowCulturalEventDetails(item)"
              ></cultural-event-item>
            </div>

            <template v-if="pastItems.length">
              <div class="agenda-section-label">{{ $t('Ended') }}</div>
              <div v-for="item in pastItems" :key="item.gid">
                <panel-item v-if="item.itemType == 0" :item="item" :showDetailsLink="true"></panel-item>
                <cultural-event-item
                  v-if="item.itemType == 1"
                  :item="item"
                  @showDetails="onShowCulturalEventDetails(item)"
                ></cultural-event-item>
              </div>
            </template>
          </template>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import axios from "@/util/axios";
import { getIconByKey } from "@/util/filters/panel-icon";
import { CollapseTransition } from "vue2-transitions";
import { mapGetters } from "vuex";
import PanelItem from "./PanelListItem";
import CulturalEventItem from "./CulturalEventListItem";

export default {
  name: "Collapse",
  components: {
    CollapseTransition,
    PanelItem,
    CulturalEventItem
  },
  props: ["name", "items", "isToday", "now"],
  data() {
    return { visible: false };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    }),
    recommendedItems() {
      return this.items.filter(i => i.isRecommended && !this.isPast(i));
    },
    currentAndFutureItems() {
      return this.items.filter(i => !i.isRecommended && !this.isPast(i));
    },
    pastItems() {
      return this.items.filter(i => this.isPast(i));
    },

    trackColor() {
      const first = this.items && this.items.find(i => i.description && i.description.thematicPathColor);
      return first ? first.description.thematicPathColor : null;
    },
    panelIcon() {
      const first = this.items && this.items.find(i => i.description && (i.description.thematicPathIconUrl || i.description.thematicPathIconKey));
      if (!first) return null;
      if (first.description.thematicPathIconUrl) return first.description.thematicPathIconUrl;
      return getIconByKey(first.description.thematicPathIconKey);
    },
    iconStyle() {
      if (!this.panelIcon) return {};
      const url = `url(${this.panelIcon})`;
      const color = this.trackColor || '#9e9e9e';
      return {
        display: 'inline-block',
        width: '24px',
        height: '24px',
        marginRight: '5px',
        marginLeft: '5px',
        verticalAlign: 'middle',
        flexShrink: '0',
        backgroundColor: color,
        maskImage: url,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: url,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
      };
    }
  },
  methods: {
    isPast(item) {
      if (!item.endDate || !this.now) return false;
      return new Date(item.endDate) <= this.now;
    },
    async onShowCulturalEventDetails(item) {
      let result = (
        await axios.get(
          "public/conferences/conference/cultural-events/details",
          {
            params: {
              id: item.id,
              language: this.language.code
            }
          }
        )
      ).data;

      var selectedItemResult = { topic: item.description.topic, html: result };
      this.$emit("selectedItem", selectedItemResult);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  display: flex;
}

.md-collapse-content {
  padding-left: 0px;
  padding-right: 0px;
}

.agenda-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #aaaaaa;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 24px 0 4px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
</style>
